import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <img
            src="/logo/logo_mini.png"
            alt="MICA Capital - Ativos Judiciais"
            className="logo-image"
          />
        </Link>

        <nav className="nav-menu">
          <Link to="/" className="nav-link">INÍCIO</Link>
          <Link to="/quem-somos" className="nav-link">QUEM SOMOS</Link>
          <Link to="/precatorios" className="nav-link">PRECATÓRIOS</Link>
          <Link to="/servicos" className="nav-link">SERVIÇOS</Link>
          <Link to="/invista-conosco" className="nav-link">INVISTA CONOSCO</Link>
          <Link to="/blog" className="nav-link">BLOG</Link>
          <Link to="/contato" className="nav-link">CONTATO</Link>
        </nav>

        <button className="btn-login" onClick={handleLoginClick}>
          Login
        </button>
      </div>
    </header>
  );
};

export default Header;
